import { Injectable } from '@angular/core';
import { ContractBillingService as ApiService } from '../contract-billing.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { GetOptionsResponseInterface } from '../_internal/interfaces';

export interface Option {
  id: string
  value: string
}

@Injectable()
export class ContractBillingUIService {

  options$: Observable<GetOptionsResponseInterface> = this.api.getOptions().pipe(shareReplay());

  bankNames$: Observable<string[]> = this.options$.pipe(map(o => {
    return o.bankNames || [];
  }));

  bankAccountTypes$: Observable<string[]> = this.options$.pipe(map(o => {
    return o.bankAccountTypes || [];
  }));

  paySources$: Observable<Option[]> = this.options$.pipe(map(o => {
    const options: Option[] = [];
    if (o.paySources) {
      Object.entries<string>(o.paySources).forEach(e => options.push({id: e[0], value: e[1]}));
    }
    return options;
  }));

  payMethods$: Observable<Option[]> = this.options$.pipe(map(o => {
    const options: Option[] = [];
    if (o.payMethods) {
      Object.entries<string>(o.payMethods).forEach(e => options.push({id: e[0], value: e[1]}));
    }
    return options;
  }));

  bookCodes$: Observable<Option[]> = this.options$.pipe(map(o => {
    const options: Option[] = [];
    if (o.bookCodes) {
      Object.entries<string>(o.bookCodes).forEach(e => options.push({id: e[0], value: e[1]}));
    }
    return options;
  }));

  editions$: Observable<Option[]> = this.options$.pipe(map(o => {
    const options: Option[] = [];
    if (o.editions) {
      Object.entries<string>(o.editions).forEach(e => options.push({id: e[0], value: e[1]}));
    }
    return options;
  }));

  contractTypes$: Observable<Option[]> = this.options$.pipe(map(o => {
    const options: Option[] = [];
    if (o.contractTypes) {
      Object.entries<string>(o.contractTypes).forEach(e => options.push({id: e[0], value: e[1]}));
    }
    return options;
  }));

  constructor(private readonly api: ApiService) {}
}
